import { TRIAL_CTA } from "../../const/publicPricing";

export const trial = { cta: TRIAL_CTA };
